import React, { useState } from 'react';
import DashboardMainContainer from '../common/Containers/DashboardMainContainer';
import { AdminPanelTitle, AdminMetric } from '../../sections/AdminDashboard/shared/adminUx';
import {
  AdminWidgetHeader,
  AdminWidgetPeriodFilter,
  AdminWidgetMetricDelta,
} from './AdminWidgetChrome';

const PerformanceWidget = ({
  className = 'masonry-item w-[470px] h-[250px] rounded-lg flex flex-col',
}) => {
  const [performanceFilterPeriod, setPerformanceFilterPeriod] = useState('7 Days');

  const performanceData = {
    '7 Days': {
      views: { value: 8512, change: 14, trend: 'up' },
      saves: { value: 791, change: 21, trend: 'up' },
      shares: { value: 144, change: 7, trend: 'down' },
      messages: { value: 56, change: 8, trend: 'up' },
      quotes: { value: 23, change: 5, trend: 'up' },
    },
    '14 Days': {
      views: { value: 17024, change: 28, trend: 'up' },
      saves: { value: 1582, change: 42, trend: 'up' },
      shares: { value: 288, change: 14, trend: 'down' },
      messages: { value: 112, change: 16, trend: 'up' },
      quotes: { value: 46, change: 10, trend: 'up' },
    },
    '30 Days': {
      views: { value: 8512, change: 18, trend: 'up' },
      saves: { value: 791, change: 45, trend: 'up' },
      shares: { value: 144, change: 12, trend: 'down' },
      messages: { value: 56, change: 15, trend: 'up' },
      quotes: { value: 89, change: 12, trend: 'up' },
    },
    '90 Days': {
      views: { value: 8512, change: 25, trend: 'up' },
      saves: { value: 791, change: 89, trend: 'up' },
      shares: { value: 144, change: 23, trend: 'down' },
      messages: { value: 56, change: 28, trend: 'up' },
      quotes: { value: 156, change: 22, trend: 'up' },
    },
    '1 Year': {
      views: { value: 8512, change: 42, trend: 'up' },
      saves: { value: 791, change: 156, trend: 'up' },
      shares: { value: 144, change: 38, trend: 'down' },
      messages: { value: 56, change: 45, trend: 'up' },
      quotes: { value: 312, change: 35, trend: 'up' },
    },
  };

  const currentData = performanceData[performanceFilterPeriod];

  const metrics = [
    { key: 'views', label: 'Views', icon: (
      <svg className="w-6 h-6 text-offblack" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
      </svg>
    ) },
    { key: 'saves', label: 'Saves', icon: (
      <svg className="w-6 h-6 text-offblack" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
      </svg>
    ) },
    { key: 'shares', label: 'Shares', icon: (
      <svg className="w-6 h-6 text-offblack" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.367 2.684 3 3 0 00-5.367-2.684z" />
      </svg>
    ) },
    { key: 'messages', label: 'Messages', icon: (
      <svg className="w-6 h-6 text-offblack" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
    ) },
    { key: 'quotes', label: 'Quotes', icon: (
      <svg className="w-6 h-6 text-offblack" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ) },
  ];

  return (
    <DashboardMainContainer className={className}>
      <AdminWidgetHeader title="Account Performance">
        <AdminWidgetPeriodFilter
          period={performanceFilterPeriod}
          onPeriodChange={setPerformanceFilterPeriod}
        />
      </AdminWidgetHeader>

      <div className="flex-1 p-4">
        <div className="grid grid-cols-5 gap-3 my-5">
          {metrics.map(({ key, label, icon }) => {
            const row = currentData[key];
            return (
              <div key={key} className="text-center">
                <div className="mx-auto mb-2 flex items-center justify-center">{icon}</div>
                <AdminPanelTitle className="text-offblack mb-2 block">{label}</AdminPanelTitle>
                <AdminMetric size="medium" className="text-offblack mb-2 block tabular-nums">
                  {row.value.toLocaleString()}
                </AdminMetric>
                <AdminWidgetMetricDelta value={row.change} trend={row.trend} />
              </div>
            );
          })}
        </div>
      </div>
    </DashboardMainContainer>
  );
};

export default PerformanceWidget;
